{
  "login": {
    "fractalIdPlaceholder": "Fractal ID ou E-mail",
    "passwordPlaceholder": "Senha",
    "createFractalIdLink": "Criar Fractal Id",
    "forgotPasswordLink": "Esqueceu a senha?",
    "loginButton": "Entrar",
    "loginError": "E-mail/Fractal Id ou senha incorretos"
  },
  "register": {
    "registerTitle": "Registrar",
    "namePlaceholder": "Nome completo",
    "emailPlaceholder": "E-mail",
    "passwordPlaceholder": "Senha",
    "confirmPasswordPlaceholder": "Repita a senha",
    "registerButton": "Registrar",
    "loginLink": "Efetuar login com Fractal ID",
    "registerError": "Não foi possível realizar o cadastro.",
    "emailInUse": "O email inserido já está em uso",
    "emailMessage": "E-mail já cadastrado! Por favor, faça login ou recupere sua senha."
  },
  "resetPassword": {
    "resetPasswordTitle": "Recuperar acesso",
    "fractalIdPlaceholder": "Digite seu E-mail",
    "passwordPlaceholder": "Senha",
    "sendButton": "Enviar",
    "backLink": "Voltar" ,
    "confirmPasswordPlaceholder": "Confirme a senha",
    "changeButton": "Alterar senha",
    "secretQuestion": "Pergunta secreta",
    "passwordResetEmailSentSuccessfully": "Um email de redefinição de senha foi enviado",
    "passwordResetEmailSentError": "Não foi possível enviar um e-mail de redefinição",
    "noSecretQuestion": "Digite um e-mail válido",
    "resetPasswordSuccess": "A senha foi redefinida",
    "resetPasswordError": "Não foi possível redefinir a senha",
    "alreadyUsedLink": "Este link já foi usado. Solicite um novo link para redefinir sua senha.",
    "invalidEmailFormat": "Formato de e-mail inválido. Por favor, insira um e-mail válido.",
    "noFindEmail": "O e-mail informado não existe em nossa base de dados."
  },
  "editUserForm": {
    "nameLabel": "Nome",
    "emailLabel": "E-mail",
    "birthdayLabel": "Data de aniversário",
    "phoneLabel": "Telefone",
    "documentLabel": "CPF",
    "genreLabel": "Sexo",
    "maleGenreLabel": "Masculino",
    "femaleGenreLabel": "Feminino",
    "zipcodeLabel": "CEP",
    "streetLabel": "Rua",
    "numberLabel": "Número",
    "complementLabel": "Complemento",
    "neighborhoodLabel": "Bairro",
    "cityLabel": "Cidade",
    "stateLabel": "Estado",
    "phoneMask": "(##) #####-####",
    "selectCountry": "Selecione seu país",
    "personalInformation": "Informações pessoais:",
    "editDataSuccess": "Dados alterados com sucesso",
    "editDataFailure": "Erro ao alterar dados",
    "updateProfileImage": "Atualizar foto de perfil",
    "removeProfileImage": "Remover foto de perfil",
    "uploadImageError": "Erro ao fazer upload da imagem",
    "uploadImageSizeError": "Insira uma imagem de até 200KB!",
    "removedImage": "Foto de perfil removida",
    "updatedImage": "Foto de perfil alterada",
    "updateImageError": "Erro ao atualizar a foto de perfil"
  },
  "securityCard": {
    "security": "Segurança",
    "securityWarning": "Mantenha seus dados atualizados para proteger seu Fractal ID",
    "changePassword": "Alterar senha",
    "changeEmail": "Alterar E-mail",
    "logoutButton": "Fazer Logout",
    "backButton": "VOLTAR",
    "editEmailSuccess": "E-mail alterado com sucesso",
    "editEmailFailure": "Erro ao alterar o E-mail",
    "editPasswordSuccess": "Senha alterada com sucesso",
    "editPasswordFailure": "Erro ao alterar a senha"
  },
  "profilePage": {
    "saveButton": "Salvar",
    "cancelButton": "Cancelar",
    "warning": "Você ainda tem alterações pendentes. Deseja mesmo sair?"
  },
  "changeEmailForm":{
    "emailFormTitle": "Alterar E-mail",
    "emailPlaceholder": "E-mail...",
    "changeButton": "Alterar"
  },
  "changePasswordForm": {
    "passwordFormTitle": "Alterar senha",
    "newPasswordPlaceholder": "Nova senha",
    "confirmPasswordPlaceholder": "Confirme a nova senha",
    "changeButton": "Alterar"
  },
  "recoverPasswordForm": {
    "passwordFormTitle": "Redefinição de senha",
    "newPasswordPlaceholder": "Nova senha",
    "confirmPasswordPlaceholder": "Confirme a nova senha",
    "changeButton": "Alterar"
  },
  "changeTemporaryPassword": {
    "passwordFormTitle": "Redefinição de senha temporária",
    "newPasswordPlaceholder": "Nova senha",
    "confirmPasswordPlaceholder": "Confirme a nova senha",
    "changeButton": "Alterar"
  }
}
